module.exports = __webpack_public_path__ + "img/reason1.3b3b6fda.png";